var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row voffset1"},[_c('div',{staticClass:"col-ms-12"},[_c('h2',[_vm._v(_vm._s(_vm.stepDisplay))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }